import React, { useState } from 'react';
import { ErrorRetrievingData } from '../../components/ErrorRetrievingData';

import { AppFooter } from '../../AppFooter';
import { FormCaderno } from '../../components/FormCaderno';
import MenuMain from '../../MenuMain';


export default function EditarCadernoPage() {

    const [caderno, setCaderno] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [errorGettingCaderno, setErrorGettingCaderno] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');


    return (
        <div className="p-pt-0">
            <MenuMain >
                {
                    errorGettingCaderno ?
                        <ErrorRetrievingData
                            errorMessage={errorMessage}
                            isLoading={isLoading}
                        />
                        :

                        <FormCaderno
                            isLoading={isLoading}
                            isEditing={true}
                        />

                }
            </MenuMain>
            <AppFooter />
        </div>
    );
}
